import request from '@/utils/request'

/**
 * 查询退货地址列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopReturnAddress(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopReturnAddress/queryShopReturnAddress',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 新增退货地址
 * @param {Object} data 新增数据
 * @returns {Promise} Promise对象
 */
export function saveShopReturnAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopReturnAddress/saveShopReturnAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 修改退货地址
 * @param {Object} data 修改数据
 * @returns {Promise} Promise对象
 */
export function updateShopReturnAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopReturnAddress/updateShopReturnAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 删除退货地址
 * @param {Object} data 删除数据
 * @returns {Promise} Promise对象
 */
export function deleteShopReturnAddress(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopReturnAddress/deleteShopReturnAddress',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}